export default __webpack_public_path__ + "static/media/instagram.c7fdbc3e.svg";